<nz-label nz-checkbox [(ngModel)]="checked" class="checkbox-disable" nzNoColon></nz-label>
<nz-form-label [attr.nzFor]="formFieldInfo.fieldCode">
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control nzValidateStatus="error" [formGroup]="formGroup">
    <input style="width:100%" nz-input type="text" [(ngModel)]="value" [disabled]="!checked" nzSize="large"
        [attr.id]="formFieldInfo.fieldCode" (ngModelChange)="onChangeValidateText()" [(ngModel)]="value" />
</nz-form-control>